<template>
  <div class="disease-course-information">
    <template v-if="!isHide">
      <div class="info2" v-if="info">
        <span>最近一次病程</span>
        <span>病程时间：{{ info.startDate }}~{{ endDate }}</span>
        <span
          >病程病种：{{ info.diseaseName }}
          <i v-if="avgCourseStr">{{ avgCourseStr }}</i>
        </span>
        <span>病程服药天数：{{ info.quantity }}天</span>
      </div>
      <div class="info3" v-if="detail">
        <div class="info-title">最近一次病程服药信息</div>
        <div class="info-body">
          <Button
            type="text"
            v-if="pageIndex == 1"
            class="edit-btn"
            @click="onEdit"
            ><Icon type="ios-create" />修改</Button
          >

          <div class="row">
            <span class="label">时间段</span>
            <span class="value">{{ detail.date }}</span>
          </div>
          <div class="row">
            <span class="label">中断</span>
            <span class="value">{{ detail.interrupt || "/" }}</span>
          </div>
          <div class="row">
            <span class="label">忌口</span>
            <span class="value">{{ detail.avoidCertainFood || "/" }}</span>
          </div>
          <div class="row">
            <span class="label">作息</span>
            <span class="value">{{ detail.workRest || "/" }}</span>
          </div>
          <div class="row">
            <span class="label">吃西药</span>
            <span class="value">{{ detail.westernMedicine || "/" }}</span>
          </div>
          <div class="row">
            <span class="label">备注</span>
            <span class="value">{{ detail.remark || "/" }}</span>
          </div>
          <div class="pagination">
            <Page
              @on-change="currentChange"
              :current="pageIndex"
              :page-size="1"
              layout="prev, pager, next"
              :total="total"
              background
              size="small"
            >
            </Page>
          </div>
        </div>
      </div>
    </template>

    <editWin
      v-model="show"
      title="记服药信息"
      :info="activeItem"
      @addSuccess="addSuccess"
      @updataSuccess="updataSuccess"
      :formInputList="formInputList"
      :isFixed="true"
      addApi="/saasbaihui/addDiseaseCourseRecord"
      updateApi="/saasbaihui/updateDiseaseCourseRecord"
      :formatData="formatData"
    >
    </editWin>
  </div>
</template>

<script>
import request from "@/utils/request";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
export default {
  props: {
    patientCode: {
      type: String,
      default: "",
    },
    isHide: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      activeItem: {},
      pageIndex: 1,
      total: 0,
      formInputList: [],
      info: {},
    };
  },
  computed: {
    detail() {
      if (!this.info.patientDisaseCourseRecordVOS) return {};
      let list = this.info.patientDisaseCourseRecordVOS;
      return list[this.pageIndex - 1];
    },
    // 用我返回的+30天 然后去和今天比，取小的
    endDate() {
      if (this.info?.endDate) {
        let d1 = dayjs(this.info.endDate).add(30, "day");
        return d1.isAfter(dayjs())
          ? dayjs().format("YYYY-MM-DD")
          : d1.format("YYYY-MM-DD");
      }
    },
    avgCourseStr() {
      let strArr = [];
      if (this.info.improveAvgCourseDays) {
        strArr.push(`平均治好疗程${this.info.improveAvgCourseDays}天`);
      }
      if (this.info.cureAvgCourseDays) {
        strArr.push(`平均治好疗程${this.info.cureAvgCourseDays}天`);
      }
      return strArr.join("；");
    },
  },
  methods: {
    formatData(data) {
      Object.assign(data, {
        patientCode: this.patientCode,
      });
      return data;
    },
    addSuccess() {
      this.getData();
    },
    updataSuccess() {
      this.getData();
    },
    currentChange(val) {
      this.pageIndex = val;
    },
    getData() {
      request
        .post("/saasbaihui/getDiseaseCourseRecord", {
          patientCode: this.patientCode,
        })
        .then((res) => {
          this.info = res.result;
          let list = this.info.patientDisaseCourseRecordVOS;
          if (list) {
            list.forEach((item) => {
              item.date =
                (item.startDate || "") + " ~ " + (item.endDate || this.endDate);
            });
            this.total = list.length;
          } else {
            this.total = 0;
          }
        });
    },
    onEdit() {
      this.activeItem = this.detail;
      this.restart();
      this.show = true;
    },
    restart() {
      this.formInputList = [
        {
          type: "date",
          field: "recordDate",
          title: "信息发生时间",
          value: "",
          required: true,
          props: {
            options: {
              disabledDate: (time) => {
                let start = dayjs(this.info.startDate);
                let end = dayjs(this.endDate);
                return !dayjs(time).isBetween(start, end, null, "[]");
              },
            },
          },
          isHide: this.activeItem ? true : false,
        },
        {
          type: "input",
          field: "date",
          title: "信息发生时间",
          value: "",
          required: false,
          disabled: true,
          isHide: this.activeItem ? false : true,
        },
        {
          type: "input",
          field: "interrupt",
          title: "中断",
          value: "",
          required: false,
        },
        {
          type: "input",
          field: "avoidCertainFood",
          title: "忌口",
          value: "",
          required: false,
        },
        {
          type: "input",
          field: "workRest",
          title: "作息",
          value: "",
          required: false,
        },
        {
          type: "input",
          field: "westernMedicine",
          title: "吃西药",
          value: "",
          required: false,
        },
        {
          type: "input",
          field: "remark",
          title: "备注",
          value: "",
          required: false,
        },
        {
          type: "input",
          field: "recordId",
          title: "ID",
          value: "",
          required: false,
          isHide: true,
        },
      ];
    },
    showEditWin() {
      this.activeItem = null;
      this.restart();
      this.show = true;
    },
  },
  mounted() {
    this.getData();
  },
};

/*
 */
</script>

<style scoped lang="scss">
.disease-course-information {
  .info2 {
    padding: 10px 15px;
    background: #f5f5f5;
    margin-bottom: 15px;
    span {
      padding-right: 20px;
      i {
        background: #fffce0;
        font-style: normal;
        font-size: 13px;
        padding: 4px 8px;
      }
    }
  }
  .info3 {
    padding: 10px 15px 15px;
    background: #f5f5f5;
    .info-title {
      padding-bottom: 10px;
    }
    .info-body {
      position: relative;
      line-height: 2.4em;
      background: #fff;
      padding: 15px;
      .label {
        display: inline-block;
        width: 100px;
        opacity: 0.6;
      }
      .pagination {
        text-align: center;
        display: flex;
        justify-content: center;
      }
    }
  }
  .edit-btn {
    position: absolute;
    right: 10px;
    top: 10px;
  }
}
</style>